import { useContext, useMemo } from "react";
import { FormContext, PaginationContext } from "dash-ui";
import { ManageMediaKitFormFields } from "containers/portfolio/ManageMediaKitModal/ManageMediaKitModal.constants";

export const useGetQueryPagination = (
  isAddedToMediaKit?: boolean,
  isMediaKit?: boolean
) => {
  const { state, getRefetchProps } = useContext(PaginationContext);
  const { skip, limit } = getRefetchProps(state);
  const { formState } = useContext(FormContext);

  const { addedMediaItems, removedMediaItems } = useMemo(() => {
    const addedMedia = formState.addedMedia?.find(
      (item: { portfolioId: string }) =>
        item.portfolioId === formState.currentPortfolioId
    );
    const removedMedia = formState.removedMedia?.find(
      (item: { portfolioId: string }) =>
        item.portfolioId === formState.currentPortfolioId
    );

    if (isMediaKit) {
      const mediaFolders = new Set(
        formState[ManageMediaKitFormFields.CurrentFoldersIds]
      );

      return {
        addedMediaItems:
          addedMedia?.mediaIds.filter((file) =>
            mediaFolders.has(file.mediaFolderId)
          ) || [],
        removedMediaItems:
          removedMedia?.mediaIds.filter((file) =>
            mediaFolders.has(file.mediaFolderId)
          ) || [],
      };
    }

    return {
      addedMediaItems: addedMedia?.mediaIds || [],
      removedMediaItems: removedMedia?.mediaIds || [],
    };
  }, [formState]);

  const { updatedFiles, files } = useMemo(() => {
    const files = !isAddedToMediaKit ? removedMediaItems : addedMediaItems;
    return { updatedFiles: files.slice(skip, skip + limit), files };
  }, [addedMediaItems, skip, limit, isAddedToMediaKit, removedMediaItems]);

  const querySkip = useMemo(() => {
    const innerSkip = state.currentPage > 0 ? skip - files.length : 0;

    return innerSkip > 0 ? innerSkip : 0;
  }, [skip, files.length, state.currentPage]);

  return {
    updatedFiles,
    addedMediaItems,
    removedMediaItems,
    paginationProps: {
      skip: querySkip,
      limit: limit - updatedFiles.length,
    },
  };
};
